<template>
  <div>
    <van-form class="q_mar_b100px">
      <van-field name="uploader" label="用户头像" input-align="right">
        <template #input>
          <van-uploader v-model="avatar" :max-count="1" :after-read="afterRead"/>
        </template>
      </van-field>
      <van-field v-model="nickName" maxlength="10" clearable label="用户昵称" placeholder="请输入用户昵称" input-align="right"/>
    </van-form>
    <van-goods-action>
      <van-goods-action-button type="danger" color="#FF5733" text="确认提交" :loading="buttonLoading" @click="updateUser"
                               :disabled="buttonLoading"
      />
    </van-goods-action>
  </div>
</template>

<script>
import {getToken} from "@/utils/auth";
import axios from "axios";
import {baseUrl, isRelogin} from "@/utils/request";
import {Dialog} from "vant";
import store from "@/store";
import {updateUser} from "@/api/user";
import {getLoginUser} from "@/api/login";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Persinfo',
  props: {
    msg: String
  },
  data() {
    return {
      buttonLoading: false,
      avatar: [{
        'url': ''
      }],
      nickName: '',
      user: {}
    }
  },
  created() {
    wxCloseShare()
    this.init()
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      getLoginUser().then(res => {
        this.user = res.data
        this.nickName = res.data.nickName
        let obj = {'url': res.data.avatar, isImage: true}
        this.avatar = [obj]
      })
    },
    /**
     * 更新信息
     */
    updateUser() {
      if (this.avatar.length == 0) {
        this.$modal.alert("请上传头像")
        return
      }
      if (!this.nickName) {
        this.$modal.alert("请输入用户昵称")
        return
      }

      this.buttonLoading = true
      let data = {'id': this.user.id, 'avatar': this.avatar[0].url, 'nickName': this.nickName}
      updateUser(data).then(res => {
        this.$store.dispatch("GetInfo")
        this.$modal.success('修改成功')
        setTimeout(() => {
          this.buttonLoading = false
          this.$router.push({
            path: '/mine'
          });
        }, 1500);
      }).finally(() => {

      })

    },
    /**
     * 文件上传
     */
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let param = new FormData();
      param.append('file', file.file);//通过append向form对象添加数据
      let config = {
        headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + getToken()}
      };
      //添加请求头
      axios.post(baseUrl + "/h5/common/upload", param, config).then(res => {
        console.log(res)
        if (res.data.code == 401) {
          Dialog.confirm({
            title: '提示', message: '登录状态已过期，您可以继续留在该页面，或者重新登录', confirmButtonText: '重新登录', cancelButtonText: '取消'
          }).then(() => {
            isRelogin.show = false
            store.dispatch('LogOut').then(() => {
              location.href = '/h5/mine/sign'
              // location.href = '/mine/sign'
            })
          }).catch(() => {
            isRelogin.show = false
          });
        } else if (res.data.code == 500) {
          this.$modal.alert('上传失败，请重新上传')
          file.status = 'failed';
          file.message = '上传失败';
        } else {
          file.status = '';
          file.message = '';
          let pic = {'url': res.data.url}
          this.avatar = [pic]
        }
      })
    }
  },
}
</script>
<style scoped="scoped">
>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-button--mini {
  margin-left: 5px;
  float: right;
}
</style>
